import { ContainerSidebar, LinkNavigate } from './styles';

import { useNavigate, useLocation, Link } from 'react-router-dom';
import { GiBrazil } from 'react-icons/gi';
import { MdPieChart } from 'react-icons/md';
import { AiFillCloseCircle } from 'react-icons/ai';
import { IoExitOutline } from 'react-icons/io5';
import Cookies from 'js-cookie';
import { useUser } from '../../hooks/useUser';

function Sidebar() {
  const location = useLocation();
  const { isOpen, setIsOpen } = useUser();

  const navigate = useNavigate();
  const navlinks = [
    // {
    //   icon: IoMdHome,
    //   route: '/home',
    //   alt: 'home',
    //   label: 'Painel',
    // },
    {
      icon: GiBrazil,
      route: '/dashboard',
      alt: 'map',
      label: 'Dashboard',
    },
    {
      icon: MdPieChart,
      route: '/detailing',
      alt: 'detailing',
      label: 'Detalhamento',
    },
    // {
    //   icon: ImUserPlus,
    //   route: '/consult',
    //   alt: 'dividas',
    //   label: 'Cadastro',
    // },
    // {
    //   icon: MdCloudUpload,
    //   route: '/home',
    //   alt: 'inclusão',
    //   label: 'Upload',
    // },
    // {
    //   icon: AiFillPieChart,
    //   route: '/report',
    //   alt: 'relatório',
    //   label: 'Relatórios',
    // },
  ];
  function logOut() {
    localStorage.clear();
    Cookies.remove('isAuthenticated');
    Cookies.remove('login');
    Cookies.remove('password');
    // window.location.href ="https://painel.acionaone.com.br/login"
    // window.location.href = "https://dashboard.negociegazin.com.br"
  }
  return (
    <ContainerSidebar isOpen={isOpen}>
      {isOpen && (
        <button
          className="close"
          onClick={setIsOpen ? () => setIsOpen(false) : () => ''}
        >
          <AiFillCloseCircle />
        </button>
      )}
      <div>
        {navlinks.map((nav) => (
          <LinkNavigate
            isActive={location.pathname === nav.route ? true : false}
            key={nav.alt}
            onClick={() => {
              navigate(nav.route);
              setIsOpen(false);
            }}
          >
            <nav.icon id={nav.alt} />
            <label htmlFor={nav.alt}>{nav.label}</label>
          </LinkNavigate>
        ))}
      </div>
      <Link to="/" onClick={logOut}>
        <IoExitOutline color="#fff" size="32px" />
        <p>Sair</p>
      </Link>
    </ContainerSidebar>
  );
}

export default Sidebar;
